<template>
  <div class="flex min-h-dvh max-h-dvh flex-col overflow-hidden bg-white">
    <BasicNavbar show-cta />
    <slot />
  </div>
</template>

<script setup lang="ts">
import BasicNavbar from '@/shared/components/BasicNavbar.vue'
</script>
